import { LightModeOutlined, DarkModeOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Data from "../Data/.json"
import SetCookie from '../Services/SetCookie';
import { resolveMode } from '../theme/theme';

const Mode = () => {

    const mode = resolveMode();
    const { t } = useTranslation();

    function SetCookieMode() {
        SetCookie(Data.mode, ((mode === "light") ? "dark" : "light"))
        window.location.reload()
    }

    return (
        <Tooltip title={(mode === "light") ? (t('mode-sombre')) : (t('mode-claire'))}>
            <IconButton
                onClick={SetCookieMode}
                aria-label={(mode === "light") ? (t('mode-sombre')) : (t('mode-claire'))}
                color="inherit"
            >
                {(mode === "light") ? <DarkModeOutlined /> : <LightModeOutlined />}
            </IconButton>
        </Tooltip>
    );
};

export default Mode;
